// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "fe60794e",
    "hash": "fe60794e",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "fe60794e",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
